<!--
 * @Description: 数据统计代理日交易统计
 * @Author: xu wei
 * @Date: 2020-02-25 14:42:03
 * @LastEditTime: 2020-09-01 16:15:47
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>数据统计</el-breadcrumb-item>
        <el-breadcrumb-item>代理日交易统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>开始时间：</span>
          <!-- <el-date-picker style="width:338px;" v-model="time" size="small" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker> -->
          <el-date-picker style="width:190px;" v-model="time1" size="small" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
          </el-date-picker> <span style="font-size:14px;">至 </span>
          <el-date-picker style="width:190px;" v-model="time2" size="small" default-time="23:59:59" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
          </el-date-picker>
        </li>
        <li>
          <span class='tit'>商户账号：</span>
          <el-input style="width:150px;" size="small" v-model="accountnumber" placeholder="请输入内容"></el-input>
          <el-button class="mgl10" size="small" type="primary" @click="()=>{pageIndex=1;getlist()}">查询</el-button>
        </li>
      </ul>
    </div>
    <div class="gs_tablebox">
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column type="index" label="序号" width="65">
        </el-table-column>
        <el-table-column prop="id" label="商户编号">
        </el-table-column>
        <el-table-column prop="tenantAccount" label="商户账号">
        </el-table-column>
        <el-table-column prop="payCount" label="充值笔数">
        </el-table-column>
        <el-table-column label="交易金额">
          <template slot-scope="scope">
            <span>{{scope.row.totalAmount.toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="商户利润">
          <template slot-scope="scope">
            <span>{{scope.row.profit.toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="比率">
          <template slot-scope="scope">
            <span>{{(scope.row.totalPercent*100).toFixed(2)+'%'}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time1: this.getCerentTime(true), // 开始时间
      time2: this.getCerentTime(false), // 开始时间
      accountnumber: '', // 商户账号
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      tableData: []
    };
  },
  methods: {
    // 代理日交易统计列表
    getlist() {
      this.$api.statics
        .agentlist({
          StartTime: this.time1 ? this.time1 : null,
          EndTime: this.time2 ? this.time2 : null,
          Account: this.accountnumber,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
</style>
